/* eslint-disable react/jsx-props-no-spreading */

import { useState } from 'react';
import { IconButton } from '../../../../components/controls';
import { TextField, TextFieldProps } from '../../../../components/form';

export default function PasswordField(props: TextFieldProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <TextField
      endAdornment={
        <IconButton
          color="default"
          icon={isPasswordVisible ? 'eye-slash' : 'eye'}
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          size="small"
        />
      }
      type={isPasswordVisible ? 'text' : 'password'}
      {...props}
    />
  );
}
